import { getEnv } from "./env-utils";

const GATSBY_SOURCE_SUSHISHOP_BASE_URL = getEnv(
  "GATSBY_SOURCE_SUSHISHOP_BASE_URL",
  process.env.GATSBY_SOURCE_SUSHISHOP_BASE_URL || ""
).replace(/(.+\/?)\/$/, "$1");
const GATSBY_ENV_COUNTRY_CODE = getEnv(
  "GATSBY_ENV_COUNTRY_CODE",
  process.env.GATSBY_ENV_COUNTRY_CODE || "FR"
);
const GATSBY_ENV_COUNTRY_ISO3166 = getEnv(
  "GATSBY_ENV_COUNTRY_ISO3166",
  GATSBY_ENV_COUNTRY_CODE
);

const GATSBY_ENV_COUNTRY_CODE_LOWER_CASE =
  GATSBY_ENV_COUNTRY_CODE.toLowerCase();

const GATSBY_INTL_DEFAULT_LANG = getEnv(
  "GATSBY_INTL_DEFAULT_LANG",
  process.env.GATSBY_INTL_DEFAULT_LANG || "fr"
);

const GATSBY_CONF_ENV = getEnv(
  "GATSBY_CONF_ENV",
  process.env.GATSBY_CONF_ENV || "dev"
);
const ENV_IS_PROD = GATSBY_CONF_ENV === "prod";
const GATSBY_ENV = getEnv("GATSBY_ENV", process.env.GATSBY_ENV || "dev");

const GATSBY_CONF_CONSUMABLE_CATEGORY_ID = getEnv(
  "GATSBY_CONF_CONSUMABLE_CATEGORY_ID",
  process.env.GATSBY_CONF_CONSUMABLE_CATEGORY_ID || ""
);
const GATSBY_CONF_REORDER_CATEGORY_ID = getEnv(
  "GATSBY_CONF_REORDER_CATEGORY_ID",
  process.env.GATSBY_CONF_REORDER_CATEGORY_ID || ""
);

const GATSBY_CONF_BAGUETTES = getEnv(
  "GATSBY_CONF_BAGUETTES",
  process.env.GATSBY_CONF_BAGUETTES || ""
);
const GATSBY_CONF_SAUCE_SUCREE = getEnv(
  "GATSBY_CONF_SAUCE_SUCREE",
  process.env.GATSBY_CONF_SAUCE_SUCREE || ""
);
const GATSBY_CONF_SAUCE_SALEE = getEnv(
  "GATSBY_CONF_SAUCE_SALEE",
  process.env.GATSBY_CONF_SAUCE_SALEE || ""
);
const GATSBY_CONF_GINGEMBRE = getEnv(
  "GATSBY_CONF_GINGEMBRE",
  process.env.GATSBY_CONF_GINGEMBRE || ""
);
const GATSBY_CONF_WASABI = getEnv(
  "GATSBY_CONF_WASABI",
  process.env.GATSBY_CONF_WASABI || ""
);
const GATSBY_CONF_HOME_DISPLAY_OTHER_CONTRY = !!parseInt(
  getEnv(
    "GATSBY_HOME_DISPLAY_OTHER_CONTRY",
    process.env.GATSBY_HOME_DISPLAY_OTHER_CONTRY || "0"
  )
);

const GATSBY_CONF_APP_GOOGLEPLAY_URL = getEnv(
  "GATSBY_CONF_APP_GOOGLEPLAY_URL",
  process.env.GATSBY_CONF_APP_GOOGLEPLAY_URL || ""
);
const GATSBY_CONF_APP_APPLESTORE_URL = getEnv(
  "GATSBY_CONF_APP_APPLESTORE_URL",
  process.env.GATSBY_CONF_APP_APPLESTORE_URL || ""
);

const GATSBY_CONF_FACEBOOK_URL = getEnv(
  "GATSBY_CONF_FACEBOOK_URL",
  process.env.GATSBY_CONF_FACEBOOK_URL || ""
);
const GATSBY_CONF_INSTAGRAM_URL = getEnv(
  "GATSBY_CONF_INSTAGRAM_URL",
  process.env.GATSBY_CONF_INSTAGRAM_URL || ""
);
const GATSBY_CONF_TWITTER_URL = getEnv(
  "GATSBY_CONF_TWITTER_URL",
  process.env.GATSBY_CONF_TWITTER_URL || ""
);
const GATSBY_CONF_LINKEDIN_URL = getEnv(
  "GATSBY_CONF_LINKEDIN_URL",
  process.env.GATSBY_CONF_LINKEDIN_URL || ""
);
const GATSBY_CONF_TIKTOK_URL = getEnv(
  "GATSBY_CONF_TIKTOK_URL",
  process.env.GATSBY_CONF_TIKTOK_URL || ""
);
const GATSBY_CONF_PINTEREST_URL = getEnv(
  "GATSBY_CONF_PINTEREST_URL",
  process.env.GATSBY_CONF_PINTEREST_URL || ""
);
// recaptcha
const GATSBY_CONF_RECAPTCHA_DESKTOP = !!parseInt(
  getEnv(
    "GATSBY_CONF_RECAPTCHA_DESKTOP",
    process.env.GATSBY_CONF_RECAPTCHA_DESKTOP || "1"
  )
);
const GATSBY_CONF_RECAPTCHA_DESKTOP_ORDER = !!parseInt(
  getEnv(
    "GATSBY_CONF_RECAPTCHA_DESKTOP_ORDER",
    process.env.GATSBY_CONF_RECAPTCHA_DESKTOP_ORDER || "1"
  )
);
const GATSBY_CONF_RECAPTCHA_DESKTOP_SITE_KEY = getEnv(
  "GATSBY_CONF_RECAPTCHA_DESKTOP_SITE_KEY",
  process.env.GATSBY_CONF_RECAPTCHA_DESKTOP_SITE_KEY || ""
);

const GATSBY_CONF_ID_CURRENCY_DEFAULT = getEnv(
  "GATSBY_CONF_ID_CURRENCY_DEFAULT",
  process.env.GATSBY_CONF_ID_CURRENCY_DEFAULT || ""
);
const GATSBY_CONF_RGPD_ENABLE_CHECK = !!parseInt(
  getEnv(
    "GATSBY_CONF_RGPD_ENABLE_CHECK",
    process.env.GATSBY_CONF_RGPD_ENABLE_CHECK || "0"
  )
);

const GATSBY_CONF_GOOGLE_MAPS_JS_API_KEY = getEnv(
  "GATSBY_CONF_GOOGLE_MAPS_JS_API_KEY",
  process.env.GATSBY_CONF_GOOGLE_MAPS_JS_API_KEY || ""
);

const GATSBY_CONF_BAGUETTES_REUTILISABLES = getEnv(
  "GATSBY_CONF_BAGUETTES_REUTILISABLES",
  process.env.GATSBY_CONF_BAGUETTES_REUTILISABLES || ""
);

const GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_MODAL = !!parseInt(
  getEnv(
    "GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_MODAL",
    process.env.GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_MODAL || "0"
  )
);
const GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN = !!parseInt(
  getEnv(
    "GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN",
    process.env.GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN || "0"
  )
);
const GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_DELAY = parseInt(
  getEnv(
    "GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_DELAY",
    process.env.GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_DELAY || "0"
  )
);

const GATSBY_CONF_CAGNOTTE_ENABLED = !!parseInt(
  getEnv(
    "GATSBY_CONF_CAGNOTTE_ENABLED",
    process.env.GATSBY_CONF_CAGNOTTE_ENABLED || "1"
  )
);

const GATSBY_CONF_SMART_REPLACE_POSTAL_CODE = !!parseInt(
  getEnv(
    "GATSBY_SMART_REPLACE_POSTAL_CODE",
    process.env.GATSBY_SMART_REPLACE_POSTAL_CODE || "0"
  )
);

const GATSBY_CONF_USE_ADVANTAGES = !!parseInt(
  getEnv(
    "GATSBY_CONF_USE_ADVANTAGES",
    process.env.GATSBY_CONF_USE_ADVANTAGES || "1"
  )
);

const GATSBY_CONF_FACEBOOK_APP_ID_WEB = getEnv(
  "GATSBY_CONF_FACEBOOK_APP_ID_WEB",
  process.env.GATSBY_CONF_FACEBOOK_APP_ID_WEB || ""
);
const GATSBY_CONF_FACEBOOK_APP_VERSION = getEnv(
  "GATSBY_CONF_FACEBOOK_APP_VERSION",
  process.env.GATSBY_CONF_FACEBOOK_APP_VERSION || ""
);
const GATSBY_CONF_GOOGLE_API_CONNECT_ID = getEnv(
  "GATSBY_CONF_GOOGLE_API_CONNECT_ID",
  process.env.GATSBY_CONF_GOOGLE_API_CONNECT_ID || ""
);

const GATSBY_CONF_CUSTOMER_ENABLE_TAX_IDENTIFICATION_NUMBER = !!parseInt(
  getEnv(
    "GATSBY_CONF_CUSTOMER_ENABLE_TAX_IDENTIFICATION_NUMBER",
    process.env.GATSBY_CONF_CUSTOMER_ENABLE_TAX_IDENTIFICATION_NUMBER || "0"
  )
);

const GATSBY_CONF_ORDER_STATE_CANCELED_DELIVERY = getEnv(
  "GATSBY_CONF_ORDER_STATE_CANCELED_DELIVERY",
  process.env.GATSBY_CONF_ORDER_STATE_CANCELED_DELIVERY || "24"
);
const GATSBY_CONF_ORDER_STATE_CANCELED_PICKUP = getEnv(
  "GATSBY_CONF_ORDER_STATE_CANCELED_PICKUP",
  process.env.GATSBY_CONF_ORDER_STATE_CANCELED_PICKUP || "28"
);
const GATSBY_CONF_ENABLE_INVOICE = !!parseInt(
  getEnv(
    "GATSBY_CONF_ENABLE_INVOICE",
    process.env.GATSBY_CONF_ENABLE_INVOICE || "0"
  )
);
const GATSBY_CONF_COMEIN_RECUP_VALUE = parseFloat(
  getEnv(
    "GATSBY_CONF_COMEIN_RECUP_VALUE",
    process.env.GATSBY_CONF_COMEIN_RECUP_VALUE || "5"
  )
);

//
//
//
const GATSBY_CONF_SHOP_NAME = getEnv(
  "GATSBY_CONF_SHOP_NAME",
  process.env.GATSBY_CONF_SHOP_NAME || "Sushi Shop"
);

const GATSBY_CONF_DEFAULT_COUNTRY_PHONE = getEnv(
  "GATSBY_CONF_DEFAULT_COUNTRY_PHONE",
  process.env.GATSBY_CONF_DEFAULT_COUNTRY_PHONE || "FR"
);

const GATSBY_CONF_PHONE_COUNTRY_SHORT_LIST = getEnv(
  "GATSBY_CONF_PHONE_COUNTRY_SHORT_LIST",
  process.env.GATSBY_CONF_PHONE_COUNTRY_SHORT_LIST ||
    GATSBY_CONF_DEFAULT_COUNTRY_PHONE
);

//
const GATSBY_CONF_MOD_POSTCODE = getEnv(
  "GATSBY_CONF_MOD_POSTCODE",
  process.env.GATSBY_CONF_MOD_POSTCODE || "default"
);
const GATSBY_CONF_MOD_POSTCODE_REGEX = getEnv(
  "GATSBY_CONF_MOD_POSTCODE_REGEX",
  process.env.GATSBY_CONF_MOD_POSTCODE_REGEX || ""
);

const GATSBY_CONF_MOD_POSTCODE_AUTOCOMPLETE = !!parseInt(
  getEnv(
    "GATSBY_CONF_MOD_POSTCODE_AUTOCOMPLETE",
    process.env.GATSBY_CONF_MOD_POSTCODE_AUTOCOMPLETE || "1"
  )
);

const GATSBY_CONF_GOOGLE_ADDRESS_SEPARATOR = getEnv(
  "GATSBY_CONF_GOOGLE_ADDRESS_SEPARATOR",
  process.env.GATSBY_CONF_GOOGLE_ADDRESS_SEPARATOR || ","
);
//
const GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_PRIMARY = getEnv(
  "GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_PRIMARY",
  process.env.GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_PRIMARY || "(.*),?"
);
const GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_SECONDARY = getEnv(
  "GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_SECONDARY",
  process.env.GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_SECONDARY || "^[0-9]+,"
);
const GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_DESCRIPTIONEND = getEnv(
  "GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_DESCRIPTIONEND",
  process.env.GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_DESCRIPTIONEND ||
    "^.*, (.*), .*|.*, .*, (.*), .*$"
);

const GATSBY_CONF_MAPBOX_ACCESS_TOKEN = getEnv(
  "GATSBY_MAPBOX_ACCESS_TOKEN",
  process.env.GATSBY_MAPBOX_ACCESS_TOKEN ||
    "pk.eyJ1IjoiYWJlZ2FyaW4iLCJhIjoiY2ppYTM0ZGZhMDE4dTN2bDlvbmN3NDUwOSJ9.0Fc_gwOjTNrgO5ZX3CqqVg"
);

const GATSBY_CONF_MAPBOX_STYLES_URL = getEnv(
  "GATSBY_CONF_MAPBOX_STYLES_URL",
  process.env.GATSBY_CONF_MAPBOX_STYLES_URL ||
    "mapbox://styles/mapbox/streets-v11"
);
const GATSBY_CONF_STORE_LOCATOR_INITIAL_ZOOM = parseInt(
  getEnv(
    "GATSBY_CONF_STORE_LOCATOR_INITIAL_ZOOM",
    process.env.GATSBY_CONF_STORE_LOCATOR_INITIAL_ZOOM || "14"
  )
);

const GATSBY_CONF_ORDER_MAP_PLACEHOLDER_ID_PICTURE = getEnv(
  "GATSBY_CONF_ORDER_MAP_PLACEHOLDER_ID_PICTURE",
  process.env.GATSBY_CONF_ORDER_MAP_PLACEHOLDER_ID_PICTURE || ""
);

const GATSBY_CONF_STORELOC_MAP_BOUNDS = getEnv(
  "GATSBY_CONF_STORELOC_MAP_BOUNDS",
  process.env.GATSBY_CONF_STORELOC_MAP_BOUNDS || "[-6.99,51.33,11.42,40.97]"
);
const GATSBY_CONF_ADDRESS_AUTOCOMPLETE_MODE = getEnv(
  "GATSBY_CONF_ADDRESS_AUTOCOMPLETE_MODE",
  process.env.GATSBY_CONF_ADDRESS_AUTOCOMPLETE_MODE || "default"
);

const GATSBY_CONF_ADDRESS_REQUIRE_STREET_NUMBER =
  getEnv(
    "GATSBY_CONF_ADDRESS_REQUIRE_STREET_NUMBER",
    process.env.GATSBY_CONF_ADDRESS_REQUIRE_STREET_NUMBER || "1"
  ) === "1";
const GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_MOBILE = parseInt(
  getEnv(
    "GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_MOBILE",
    process.env.GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_MOBILE ||
      "1500"
  )
);
const GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_DESKTOP = parseInt(
  getEnv(
    "GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_DESKTOP",
    process.env.GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_DESKTOP ||
      "500"
  )
);
const GATSBY_CONF_ADDRESS_AUTOCOMPLETE_SHORT_IGNORE = parseInt(
  getEnv(
    "GATSBY_CONF_ADDRESS_AUTOCOMPLETE_SHORT_IGNORE",
    process.env.GATSBY_CONF_ADDRESS_AUTOCOMPLETE_SHORT_IGNORE || "3"
  )
);

const GATSBY_CONF_IS_AVIS_VERIFIE_ACTIVE = !!parseInt(
  getEnv(
    "GATSBY_CONF_IS_AVIS_VERIFIE_ACTIVE",
    process.env.GATSBY_CONF_IS_AVIS_VERIFIE_ACTIVE || "0"
  )
);

const GATSBY_CONF_ENERGY_DECIMALS_SIGN = getEnv(
  "GATSBY_CONF_ENERGY_DECIMALS_SIGN",
  process.env.GATSBY_CONF_ENERGY_DECIMALS_SIGN || ","
);
const GATSBY_CONF_ENERGY_UNIT = getEnv(
  "GATSBY_CONF_ENERGY_UNIT",
  process.env.GATSBY_CONF_ENERGY_UNIT || "%s kJ."
);
const GATSBY_CONF_ENERGY_ROUND_ZERO = !!parseInt(
  getEnv(
    "GATSBY_CONF_ENERGY_ROUND_ZERO",
    process.env.GATSBY_CONF_ENERGY_ROUND_ZERO || "1"
  )
);
const GATSBY_CONF_ENERGY_CONVERSION_RATE = parseInt(
  getEnv(
    "GATSBY_CONF_ENERGY_CONVERSION_RATE",
    process.env.GATSBY_CONF_ENERGY_CONVERSION_RATE || "1"
  )
);
const GATSBY_CONF_ENERGY_DECIMALS = parseInt(
  getEnv(
    "GATSBY_CONF_ENERGY_DECIMALS",
    process.env.GATSBY_CONF_ENERGY_DECIMALS || "0"
  )
);

const GATSBY_CONF_LUNCH_DINER_SERVICE_THRESHOLD_TIME = getEnv(
  "GATSBY_CONF_LUNCH_DINER_SERVICE_THRESHOLD_TIME",
  process.env.GATSBY_CONF_LUNCH_DINER_SERVICE_THRESHOLD_TIME || "16:00:00"
);

const GATSBY_CONF_DIFFER_MAX_WEEKS = parseInt(
  getEnv(
    "GATSBY_CONF_DIFFER_MAX_WEEKS",
    process.env.GATSBY_CONF_DIFFER_MAX_WEEKS || "5"
  )
);

const GATSBY_CONF_CVC_CART_MIN_DISPLAY = parseInt(
  getEnv(
    "GATSBY_CONF_CVC_CART_MIN_DISPLAY",
    process.env.GATSBY_CONF_CVC_CART_MIN_DISPLAY || "100"
  )
);

const GATSBY_NO_COMEIN = !!parseInt(
  getEnv("GATSBY_NO_COMEIN", process.env.GATSBY_NO_COMEIN || "0")
);
const GATSBY_CONF_MY_SUSHI_SHOP_ENABLED = !!parseInt(
  getEnv(
    "GATSBY_CONF_MY_SUSHI_SHOP_ENABLED",
    process.env.GATSBY_CONF_MY_SUSHI_SHOP_ENABLED || "0"
  )
);
const GATSBY_CONF_MY_SUSHI_SHOP_HIDE_PROGRESS = !!parseInt(
  getEnv(
    "GATSBY_CONF_MY_SUSHI_SHOP_HIDE_PROGRESS",
    process.env.GATSBY_CONF_MY_SUSHI_SHOP_HIDE_PROGRESS || "0"
  )
);
const GATSBY_CONF_MY_SUSHI_SHOP_ORDER_BONUS_COUNT = parseInt(
  getEnv(
    "GATSBY_CONF_MY_SUSHI_SHOP_ORDER_BONUS_COUNT",
    process.env.GATSBY_CONF_MY_SUSHI_SHOP_ORDER_BONUS_COUNT || "4"
  )
);
const GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_MIN_TOTAL_PRICE = parseFloat(
  getEnv(
    "GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_MIN_TOTAL_PRICE",
    process.env.GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_MIN_TOTAL_PRICE || "20"
  )
);
const GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_VALUE = parseFloat(
  getEnv(
    "GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_VALUE",
    process.env.GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_VALUE || "5"
  )
);

// cette configuration est temporaire, pour le lancement des Happy Hours et permet de faire des HH silencieuses.
const GATSBY_CONF_HAPPY_HOURS_SHOW_CONFIRMATION_MESSAGE =
  parseInt(
    getEnv(
      "GATSBY_CONF_HAPPY_HOURS_SHOW_CONFIRMATION_MESSAGE",
      process.env.GATSBY_CONF_HAPPY_HOURS_SHOW_CONFIRMATION_MESSAGE || "1"
    )
  ) === 1;

const GATSBY_ENV_TIMEZONE = process.env.GATSBY_ENV_TIMEZONE || "Europe/Paris";

// Image CDN base URL
const GATSBY_WEB_ASSET_PREFIX = process.env.GATSBY_WEB_ASSET_PREFIX || "";
const GATSBY_CONF_DOMAIN_SHARDING_IMG =
  process.env.GATSBY_CONF_DOMAIN_SHARDING_IMG || "";
const IMAGE_CDN_BASE_URL = GATSBY_CONF_DOMAIN_SHARDING_IMG
  ? `https://${GATSBY_CONF_DOMAIN_SHARDING_IMG}`
  : (GATSBY_WEB_ASSET_PREFIX || "").replace(/\/rollingstart\/$/g, "");

export {
  GATSBY_CONF_ENV,
  ENV_IS_PROD,
  GATSBY_ENV,
  GATSBY_ENV_COUNTRY_CODE,
  GATSBY_ENV_COUNTRY_CODE_LOWER_CASE,
  GATSBY_ENV_COUNTRY_ISO3166,
  GATSBY_SOURCE_SUSHISHOP_BASE_URL,
  GATSBY_INTL_DEFAULT_LANG,
  //
  GATSBY_CONF_SHOP_NAME,
  GATSBY_CONF_HOME_DISPLAY_OTHER_CONTRY,
  //
  GATSBY_CONF_CONSUMABLE_CATEGORY_ID,
  GATSBY_CONF_REORDER_CATEGORY_ID,
  //
  //
  GATSBY_CONF_APP_APPLESTORE_URL,
  GATSBY_CONF_APP_GOOGLEPLAY_URL,
  //
  GATSBY_CONF_FACEBOOK_URL,
  GATSBY_CONF_INSTAGRAM_URL,
  GATSBY_CONF_TWITTER_URL,
  GATSBY_CONF_LINKEDIN_URL,
  GATSBY_CONF_TIKTOK_URL,
  GATSBY_CONF_PINTEREST_URL,
  //
  GATSBY_CONF_RECAPTCHA_DESKTOP,
  GATSBY_CONF_RECAPTCHA_DESKTOP_ORDER,
  GATSBY_CONF_RECAPTCHA_DESKTOP_SITE_KEY,
  //
  GATSBY_CONF_MOD_POSTCODE,
  GATSBY_CONF_MOD_POSTCODE_REGEX,
  GATSBY_CONF_MOD_POSTCODE_AUTOCOMPLETE,
  GATSBY_CONF_SMART_REPLACE_POSTAL_CODE,
  GATSBY_CONF_GOOGLE_ADDRESS_SEPARATOR,
  GATSBY_CONF_ID_CURRENCY_DEFAULT,
  GATSBY_CONF_RGPD_ENABLE_CHECK,
  GATSBY_CONF_BAGUETTES_REUTILISABLES,
  GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_MODAL,
  GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN,
  GATSBY_CONF_BAGUETTES_REUTILISABLES_WARN_DELAY,
  //
  GATSBY_CONF_CAGNOTTE_ENABLED,
  GATSBY_CONF_USE_ADVANTAGES,
  //
  GATSBY_CONF_BAGUETTES,
  GATSBY_CONF_SAUCE_SUCREE,
  GATSBY_CONF_SAUCE_SALEE,
  GATSBY_CONF_GINGEMBRE,
  GATSBY_CONF_WASABI,
  //
  GATSBY_CONF_FACEBOOK_APP_ID_WEB,
  GATSBY_CONF_FACEBOOK_APP_VERSION,
  GATSBY_CONF_GOOGLE_API_CONNECT_ID,
  //
  GATSBY_CONF_PHONE_COUNTRY_SHORT_LIST,
  GATSBY_CONF_DEFAULT_COUNTRY_PHONE,
  //
  GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_PRIMARY,
  GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_SECONDARY,
  GATSBY_CONF_GOOGLE_ADDRESS_REG_EXP_DESCRIPTIONEND,
  GATSBY_CONF_GOOGLE_MAPS_JS_API_KEY,
  GATSBY_CONF_ADDRESS_AUTOCOMPLETE_MODE,
  GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_MOBILE,
  GATSBY_CONF_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_DESKTOP,
  GATSBY_CONF_ADDRESS_AUTOCOMPLETE_SHORT_IGNORE,
  GATSBY_CONF_ADDRESS_REQUIRE_STREET_NUMBER,
  GATSBY_CONF_MAPBOX_ACCESS_TOKEN,
  GATSBY_CONF_MAPBOX_STYLES_URL,
  GATSBY_CONF_STORE_LOCATOR_INITIAL_ZOOM,
  GATSBY_CONF_ORDER_MAP_PLACEHOLDER_ID_PICTURE,
  GATSBY_CONF_STORELOC_MAP_BOUNDS,
  //
  GATSBY_CONF_CUSTOMER_ENABLE_TAX_IDENTIFICATION_NUMBER,
  //
  GATSBY_CONF_ORDER_STATE_CANCELED_DELIVERY,
  GATSBY_CONF_ORDER_STATE_CANCELED_PICKUP,
  GATSBY_CONF_ENABLE_INVOICE,
  GATSBY_CONF_COMEIN_RECUP_VALUE,
  //
  GATSBY_CONF_IS_AVIS_VERIFIE_ACTIVE,
  //
  GATSBY_CONF_ENERGY_DECIMALS_SIGN,
  GATSBY_CONF_ENERGY_UNIT,
  GATSBY_CONF_ENERGY_ROUND_ZERO,
  GATSBY_CONF_ENERGY_CONVERSION_RATE,
  GATSBY_CONF_ENERGY_DECIMALS,
  //
  GATSBY_CONF_LUNCH_DINER_SERVICE_THRESHOLD_TIME,
  GATSBY_CONF_DIFFER_MAX_WEEKS,
  GATSBY_CONF_CVC_CART_MIN_DISPLAY,
  //
  GATSBY_NO_COMEIN,
  GATSBY_CONF_MY_SUSHI_SHOP_ENABLED,
  GATSBY_CONF_MY_SUSHI_SHOP_ORDER_BONUS_COUNT,
  GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_MIN_TOTAL_PRICE,
  GATSBY_CONF_MY_SUSHISHOP_ORDER_BONUS_VALUE,
  GATSBY_CONF_MY_SUSHI_SHOP_HIDE_PROGRESS,
  //
  GATSBY_CONF_HAPPY_HOURS_SHOW_CONFIRMATION_MESSAGE,
  //
  GATSBY_ENV_TIMEZONE,
  //
  IMAGE_CDN_BASE_URL,
};
